import { createFileRoute } from '@tanstack/react-router';
import { useIntl } from 'react-intl';
import { LegalPage } from '../components/LegalPage.tsx';
import { termsDocs } from '../content/legal/index.ts';
import { useRouteMeta } from '../lib/useDocumentMeta.ts';
import type { Locale } from '../intl/index.ts';

export const Route = createFileRoute('/terms')({
  component: TermsPage,
});

function TermsPage() {
  useRouteMeta('meta.terms.title', 'meta.terms.description');
  const { locale } = useIntl();
  const doc = termsDocs[locale as Locale] ?? termsDocs.en;
  return <LegalPage doc={doc} />;
}
